var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Liquidacion","hide-footer":"","size":"lg","id":"liquidacion"}},[_c('info-coberturas'),_c('info-bienes'),_c('btn-pdf')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }